const subscriptionTypes = {
    1: "Subskrypcja miesięczna",
    2: "Subskrypcja roczna",
}

export default subscriptionTypes